<template>
  <section class="container">
    <div class="row justify-content-center justify-content-md-between mb-3 ml-2 ml-sm-0">
      <mdb-btn
        flat
        dark-waves
        icon="arrow-left"
        type="button"
        title="Regresar"
        @click="$router.go(-1)"
      >
        Regresar
      </mdb-btn>
    </div>
    <div class="encabezado-detalles">
      <header class="h4-responsive text-center pt-3">Reporte</header>
      <div class="row mx-0 mt-2">
        <div class="col-12 col-md-4">
          <span class="small-block font-titulo">Nombre del reporte</span>
          <p>
            Efectividad de cobranza
          </p>
        </div>
        <div class="col-12 col-sm">
          <span class="small-block font-titulo">Periodo mostrado</span>
          <p v-if="fechaDel.length && fechaHasta.length">
            Desde el {{ formatearFecha(fechaDel).ddmmyyyy }} hasta el {{ formatearFecha(fechaHasta).ddmmyyyy }}
          </p>
          <p v-else>
            Mes {{ fechaResumen }}
          </p>
        </div>
        <div class="col-12">
          <span class="small-block font-titulo">Descripción</span>
          <p>
            Visualiza la efectividad de la gestión de cobranza de tu cartera al día, comparando los saldos vencidos
            y por vencer contra los montos efectivamente recuperados.
          </p>
          <p>
            Proporciona los porcentajes de distribución del saldo total y el índice de efectividad de cobro. Las
            facturas se seleccionan por su fecha de vencimiento; los pagos se contabilizan sin importar la fecha
            del abono. Solo se muestran tus propios datos de vendedor.
          </p>
        </div>
      </div>
    </div>
    <div class="row align-items-center mb-3">
      <div class="col-12 col-sm-6 col-lg-3">
        <mdb-input
          v-model="fechaResumen"
          type="month"
          class="my-2"
          label="Mes"
          outline
        />
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <mdb-input
          v-model="fechaDel"
          type="date"
          class="my-2"
          label="Desde"
          outline
        />
      </div>
      <div class="col-12 col-sm-6 col-lg-3">
        <mdb-input
          v-model="fechaHasta"
          type="date"
          class="my-2"
          label="Hasta"
          outline
        />
      </div>
      <div class="col text-center px-0">
        <mdb-btn
          flat
          dark-waves
          icon="broom"
          class="my-1 px-3"
          @click="eliminarFiltrosSeleccionados"
        >
          Restablecer filtros
        </mdb-btn>
      </div>
    </div>
    <div
      v-if="cargando"
      class="mensaje-no-items py-3"
    >
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <div
      v-else-if="!cobranza.length"
      class="mensaje-no-items py-3"
    >
      <font-awesome-icon
        icon="clipboard-list"
        size="5x"
        class="icono"
      />
      <p class="texto">No hay datos según los parámetros seleccionados</p>
    </div>
    <div
      v-else
      class="table-container"
    >
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Vendedor</th>
              <th>Vencido</th>
              <th>Por vencer</th>
              <th>Cobrado</th>
              <th>Total</th>
              <th>% Vencido</th>
              <th>% Por vencer</th>
              <th>% Cobrado</th>
              <th>% Efectividad de cobranza</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(cob, index) in cobranza"
              :key="index"
              :class="{ 'fila-totales': cob.vendedor === 'TOTAL' }"
            >
              <td data-columna="Vendedor">{{ cob.vendedor }}</td>
              <td data-columna="Vencido">{{ cob.vencido }}</td>
              <td data-columna="Por vencer">{{ cob.por_vencer }}</td>
              <td data-columna="Cobrado">{{ cob.cobrado }}</td>
              <td data-columna="Total">{{ cob.total }}</td>
              <td data-columna="% Vencido">{{ cob.pct_vencido }}%</td>
              <td data-columna="% Por vencer">{{ cob.pct_por_vencer }}%</td>
              <td data-columna="% Cobrado">{{ cob.pct_cobrado }}%</td>
              <td data-columna="% Efectividad de cobranza">{{ cob.efectividad_cobranza }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <AlertaMensaje
      :alerta-mensaje="alertaMensaje"
      @cerrar="alertaMensaje.contenido = ''"
    />
  </section>
</template>

<script>
import {mdbInput, mdbBtn} from 'mdbvue';
import {apiPost} from '@/funciones/api.js';
import LoaderKel from '@/components/LoaderKel.vue';
import AlertaMensaje from '@/components/AlertaMensaje.vue';
import {
  formatearFecha,
} from '@/funciones/funciones.js';

export default {
  name: 'EfectividadCobranza',

  components: {
    mdbInput,
    mdbBtn,
    LoaderKel,
    AlertaMensaje,
  },
  data() {
    return {
      fechaResumen: new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2),
      fechaDel: '',
      fechaHasta: '',
      cobranza: [],
      cargando: false,
      timeout: null,
      alertaMensaje: {
        contenido: '',
        tipo: '',
      },
      formatearFecha,
    };
  },
  watch: {
    fechaResumen() {
      this.fechaDel = '';
      this.fechaHasta = '';
      this.aplicarFiltros();
    },
    fechaDel() {
      this.aplicarFiltros();
    },
    fechaHasta() {
      this.aplicarFiltros();
    },
  },
  mounted() {
    this.aplicarFiltros();
  },
  methods: {
    aplicarFiltros() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        const tieneDesde = this.fechaDel.length > 0;
        const tieneHasta = this.fechaHasta.length > 0;
        if (tieneDesde !== tieneHasta) {
          this.alertaMensaje = {
            contenido: 'Complete "Desde" y "Hasta" para consultar un rango de fechas, o limpie ambas para consultar por mes.',
            tipo: 'warning',
          };
          return;
        }
        this.alertaMensaje.contenido = '';
        this.cargando = true;
        const data = tieneDesde ?
          `desde=${this.fechaDel}&hasta=${this.fechaHasta}` :
          `ano=${this.fechaResumen.split('-')[0]}&mes=${this.fechaResumen.split('-')[1]}`;
        apiPost({s: 'efectividadMv'}, data)
            .then((res) => {
              this.cobranza = (res.data && res.data.cob) || [];
            })
            .catch(() => {
              this.alertaMensaje = {
                contenido: 'Ocurrió un error obteniendo el reporte de efectividad de cobranza.',
                tipo: 'error',
              };
            })
            .finally(() => {
              this.cargando = false;
            });
      }, 800); // delay
    },
    eliminarFiltrosSeleccionados() {
      this.fechaDel = '';
      this.fechaHasta = '';
      this.fechaResumen = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2);
      this.aplicarFiltros();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: .6rem .4rem .6rem .4rem;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .3rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .9rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.fila-totales {
  background-color: #f0f4f8;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
}

.fila-totales td {
  border-bottom: none;
  background-color: #f0f4f8;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%;
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 140px;
    width: 140px !important;
    flex-shrink: 0;
  }
}
</style>
